import { handleRoute } from "../https";

export async function findEmployeeAdjustments({ companyId, employeeId }) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/employees/${employeeId}/employee-adjustments`,
  });
  return res;
}
